<script>
  import { onMount } from "svelte";
  import * as PropTypes from "prop-types";
  export let color = "#000";
  export let size = "18px";
  const { checkPropTypes, string } = PropTypes;
  const propTypes = {
    color: string,
    size: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "Loader");
  });
</script>

<div aria-label="loader" style="width: {size}">
  <svg class="spinner" viewBox="0 0 50 50">
    <circle
      class="path"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke-width="6"
      style="stroke: {color}"
    />
  </svg>
</div>

<style scoped>
  .spinner {
    animation: rotate 2s linear infinite;
  }

  .path {
    stroke: hsl(210, 70, 75);
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
</style>
